import { type AxiosRequestConfig, httpClient } from '@ahm/api-wrappers-core';
import type { UpdateStopInfoRequest, UpdateStopInfoResponse } from '..';
import { apiRoutes } from '../../api-routes';

export const updateStopInfoFn = async (
  orderId: string,
  body: UpdateStopInfoRequest,
  config: AxiosRequestConfig = {}
) => {
  const response = await httpClient.patch<UpdateStopInfoResponse>(
    apiRoutes.order.stopInformation(orderId),
    body,
    config
  );
  return response.data;
};
